import React from "react";
import {useFormik} from "formik";
import {useNavigate} from "react-router-dom";
import * as yup from "yup";
import {Grid} from "@mui/system";
import style from "../../assets/css/login-register.module.scss";
import {GoArrowLeft} from "react-icons/go";
import {Button, FormControl, InputLabel} from "@mui/material";
import GlobalTextField from "../global-fields/GlobalTextField";
import {Link} from "react-router-dom";
import {FORGOT_PASS} from "../../constants/apiConstant";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {selectUiState, setUiData} from "../../store/uiSlice";
import {removeCookies} from "../../constants/helper";
import {useDispatch, useSelector} from "react-redux";

const ForgotPassword = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // const [rememberMe, setRememberMe] = useState(false);
  // const [isLoading, setIsLoading] = useState(false);
  const {dynamicHeaderHeight} = useSelector(selectUiState);

  let initialFormikVals = {
    email: "",
  };

  const handleSubmit = async (e) => {
    // setIsLoading(true);
    dispatch(
      setUiData({
        showLoader: true,
      })
    );
    let data = {...e};

    const options = {
      method: FORGOT_PASS.method,
      headers: FORGOT_PASS.headers,
      body: JSON.stringify(data),
    };

    fetch(FORGOT_PASS.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          // setIsLoading(false);
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          GlobalNotificationPopup({type: "error", message: res?.message});
          removeCookies("isLogin");
        } else if (res.status == 1) {
          GlobalNotificationPopup({type: "success", message: res?.message});
          // setIsLoading(false);
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          removeCookies("isLogin");
          navigate(`/`);
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        // setIsLoading(false);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
        formik.resetForm();
      });
  };

  const formik = useFormik({
    initialValues: initialFormikVals,
    onSubmit: (values) => {
      handleSubmit(values);
    },
    validationSchema: yup.object({
      email: yup
        .string()
        .email("Must be a valid email.")
        .required("Email is required!"),
    }),
  });

  return (
    <>
      <div
        className={style.logMainWrapper}
        style={{height: `calc(100vh - ${dynamicHeaderHeight}px)`}}
      >
        <div className={style.logLeftMain}>
          <Grid container spacing={1} justifyContent="center">
            <Grid size={{xs: 12, lg: 7, xl: 6}}>
              <div className={style.log_title}>
                <h2> Forgot Password </h2>
                <p> No worries, we’ll send you a reset password link. </p>
              </div>

              <form
                autoComplete="false"
                autoSave="false"
                onSubmit={formik.handleSubmit}
              >
                <Grid container spacing={1} justifyContent="center">
                  <Grid size={{xs: 12, lg: 12}} className={style.logLabel}>
                    <InputLabel
                      sx={{mb: 1}}
                      htmlFor="my-input"
                      style={{color: "black"}}
                    >
                      Email address
                    </InputLabel>
                    <FormControl fullWidth variant="outlined">
                      <GlobalTextField
                        id="email"
                        type="email"
                        value={formik.values.email}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        name="email"
                        error={
                          formik.touched.email && Boolean(formik.errors.email)
                        }
                        helperText={formik.touched.email && formik.errors.email}
                      />
                    </FormControl>
                  </Grid>

                  <Grid size={{xl: 12, xs: 12}}>
                    <div className={style.logBtnMain}>
                      <Button
                        fullWidth
                        variant="contained"
                        className={style.logResetBtn}
                        type="submit"
                      >
                        Get Reset Password Link
                      </Button>
                      <Link to="/login">
                        <Button variant="outline" className={style.logBackBtn}>
                          <GoArrowLeft /> Back to Login
                        </Button>
                      </Link>
                    </div>
                  </Grid>
                </Grid>
              </form>
            </Grid>
          </Grid>
        </div>

        {/* Back image div start */}
        <div className={style.logRightMain}>
          <div className={style.logRightWrapper}></div>
        </div>
        {/* Back image div end */}
      </div>
    </>
  );
};

export default ForgotPassword;
